'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToastFooter", {
    enumerable: true,
    get: function() {
        return ToastFooter;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToastFooter = require("./useToastFooter");
const _renderToastFooter = require("./renderToastFooter");
const _useToastFooterStylesstyles = require("./useToastFooterStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ToastFooter = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToastFooter.useToastFooter_unstable)(props, ref);
    (0, _useToastFooterStylesstyles.useToastFooterStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToastFooterStyles_unstable')(state);
    return (0, _renderToastFooter.renderToastFooter_unstable)(state);
});
ToastFooter.displayName = 'ToastFooter';
